/**
 * Página de Inicio del Dashboard
 * Presenta la marca Mi Pymex y una descripción profesional de la plataforma PipeEnLinea.
 */

'use client';

import React from 'react';
import Image from 'next/image';
import { Icon } from '@/components/ui/icons';

export default function HomePage() {
  return (
    <div className="home-page">
      {/* Hero: Logo y bienvenida */}
      <section className="home-hero">
        <div className="home-hero-card">
          <div className="home-logo-wrap">
            <Image
              src="/Imagenes/MiPymex_Logotipo.png"
              alt="Mi Pymex"
              width={220}
              height={88}
              priority
              className="home-logo-img"
            />
          </div>
          <p className="home-tagline">Plataforma de Gestión</p>
          <div className="home-badge">
            <span className="home-badge-dot" />
            PipeEnLinea
          </div>
        </div>
      </section>

      {/* Descripción */}
      <section className="home-intro">
        <div className="home-intro-card">
          <h2 className="home-intro-title">Bienvenido a PipeEnLinea</h2>
          <p className="home-intro-text">
            Plataforma integral para la gestión y administración del ciclo de vida de las solicitudes
            de crédito. Desde la captación inicial hasta el fondeo, con seguimiento eficiente,
            coordinación entre áreas y procesos operativos optimizados.
          </p>
        </div>
      </section>

      {/* Características */}
      <section className="home-features">
        <div className="home-features-grid">
          <article className="home-feature-card">
            <div className="home-feature-icon">
              <Icon name="file" size={24} color="#0196A1" />
            </div>
            <h3 className="home-feature-title">Gestión de Solicitudes</h3>
            <p className="home-feature-text">
              Administra y da seguimiento a todas las solicitudes de crédito en un solo lugar.
            </p>
          </article>

          <article className="home-feature-card">
            <div className="home-feature-icon">
              <Icon name="chart" size={24} color="#0196A1" />
            </div>
            <h3 className="home-feature-title">Análisis y Reportes</h3>
            <p className="home-feature-text">
              Reportes detallados y análisis para la toma de decisiones estratégicas.
            </p>
          </article>

          <article className="home-feature-card">
            <div className="home-feature-icon">
              <Icon name="users" size={24} color="#0196A1" />
            </div>
            <h3 className="home-feature-title">Control de Accesos</h3>
            <p className="home-feature-text">
              Permisos granulares para garantizar la seguridad de la información.
            </p>
          </article>

          <article className="home-feature-card">
            <div className="home-feature-icon">
              <Icon name="check" size={24} color="#0196A1" />
            </div>
            <h3 className="home-feature-title">Flujo de Trabajo</h3>
            <p className="home-feature-text">
              Procesos con flujos automatizados y personalizables.
            </p>
          </article>
        </div>
      </section>

      {/* Footer */}
      <footer className="home-footer">
        <p className="home-footer-text">
          © {new Date().getFullYear()} Mi Pymex S.A. de C.V., SOFOM, E.N.R. — Todos los derechos reservados
        </p>
      </footer>
    </div>
  );
}
